var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1713 417L1713 445",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1713.5,
    cy: 412.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1712.08 417.222H1714.92V413.917H1718.22V411.083H1714.92V407.778H1712.08V411.083H1708.78V413.917H1712.08V417.222ZM1706.89 421C1706.37 421 1705.92 420.815 1705.55 420.445C1705.18 420.075 1705 419.631 1705 419.111V405.889C1705 405.369 1705.18 404.925 1705.55 404.555C1705.92 404.185 1706.37 404 1706.89 404H1720.11C1720.63 404 1721.08 404.185 1721.45 404.555C1721.82 404.925 1722 405.369 1722 405.889V419.111C1722 419.631 1721.82 420.075 1721.45 420.445C1721.08 420.815 1720.63 421 1720.11 421H1706.89ZM1706.89 419.111H1720.11V405.889H1706.89V419.111Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital1);
export default __webpack_public_path__ + "static/media/hospital_1.31e55c1c4ac9bdaf5d34ef1fd3800d82.svg";
export { ForwardRef as ReactComponent };